<template>
    <v-form class="d-flex align-center finish-reset-password" style="height: 95vh" v-model="valid">
        <v-container>
            <v-row>
                <v-col class="pr-7" cols="4">
                    <h1>{{ $t('resetYourPassword') }}</h1>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="pr-7" cols="4">
                    <h3 class="mb-5">{{ $t('form_FinishResetPassword.createNewPassword.header') }}</h3>
                    <v-text-field
                        :rules="passwordRule"
                        :label="$t('form_FinishResetPassword.createNewPassword.label')"
                        :type="showPassword ? 'text' : 'password'"
                        :append-icon="showPassword ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye'"
                        @click:append="showPassword = !showPassword"
                        outlined
                        v-model="password"
                    />
                </v-col>
                <v-col class="pr-7" cols="4">
                    <h3 class="mb-5">{{ $t('form_FinishResetPassword.confirmNewPassword.header') }}</h3>
                    <v-text-field
                        :rules="confirmPasswordRule"
                        :label="$t('form_FinishResetPassword.confirmNewPassword.label')"
                        :type="showConfirmPassword ? 'text' : 'password'"
                        :append-icon="showConfirmPassword ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye'"
                        @click:append="showConfirmPassword = !showConfirmPassword"
                        outlined
                        v-model="confirmPassword"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="5">
                    <v-btn @click="resetPassword" class="text-center" v-on:keyup.enter="resetPassword">{{ $t('setNewPassword') }}</v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
    import Repository from '../../../repositories/auth';
    export default {
        name: "FinishResetPassword",
        data() {
            return {
                valid: false,
                key: '',
                password: '',
                confirmPassword: '',
                showPassword: false,
                showConfirmPassword: false,
                passwordRule: [
                    p => !!p || this.$t('form_FinishResetPassword.createNewPassword.rule1'),
                    p => (p || '' ).length < 60 || this.$t('form_FinishResetPassword.createNewPassword.rule2'),
                    p => (p || '' ).length > 7 || this.$t('form_FinishResetPassword.createNewPassword.rule3'),
                ],
                confirmPasswordRule: [
                    p => !!p || this.$t('form_FinishResetPassword.confirmNewPassword.rule1'),
                    p => p === this.password || this.$t('form_FinishResetPassword.confirmNewPassword.rule2'),
                ],
            };
        },
        created() {
            this.key = this.$route.query.key;
        },
        methods: {
            resetPassword() {
                if(this.valid) {
                    Repository.finishResetPassword(this.password, this.key).then((response) => {
                        if(response.status < 400) {
                            setTimeout(() => {
                                alert(this.$t('yourPasswordHasBeenReset'));
                                this.$router.push({ name: 'login' });
                            }, 2000);
                        }
                    });
                }
            },
        },
    }
</script>

<style lang="scss">
.finish-reset-password{
    button{
        border: none transparent !important;
        &:hover{
            background-color: transparent !important;
        }
    }
}
</style>


